// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-right {
  right: 0;
  left: auto !important;
}

.dropdown-menu.arrow:before {
    left: 70px !important;
    border-bottom-color: #ffffff;
}

.dropdown-menu.arrow:after {
    top: 0px;
}

@media only screen and (max-width:767px) {
  ._dropdown_mob {
      margin-left: 150px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/breadcrumb/breadcrumb.component.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,qBAAqB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,QAAQ;AACZ;;AAEA;EACE;MACI,6BAA6B;EACjC;AACF","sourcesContent":[".dropdown-menu-right {\n  right: 0;\n  left: auto !important;\n}\n\n.dropdown-menu.arrow:before {\n    left: 70px !important;\n    border-bottom-color: #ffffff;\n}\n\n.dropdown-menu.arrow:after {\n    top: 0px;\n}\n\n@media only screen and (max-width:767px) {\n  ._dropdown_mob {\n      margin-left: 150px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
